// extracted by mini-css-extract-plugin
module.exports = {"introText":"style-module__introText___a5fji","location":"style-module__location___1tdqC"};